export enum ResetPasswordState{
	NewPassword = 1,
	ResetPasswordExpired = 2,
	PasswordChanged = 3
}